import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=e4226f86&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=e4226f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4226f86",
  null
  
)

export default component.exports